import HiddenInput from './HiddenInput';

export default HiddenInput;
